/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '移交单号',
                'value': 'transferNo',
                'type': 'input',
                'unfold': true,
                'span': 4
            }, {
                'name': '接收时间',
                'value': 'searchTime',
                'type': 'time',
                'unfold': true,
                'span': 7,
                timeNum: 3,
                'startPlaceholder': '移交开始日期',
                'endPlaceholder': '移交结束日期'
            }, {
                'name': '移交状态',
                'value': 'transferStatus',
                'type': 'select',
                'unfold': true,
                'span': 4,
                'optionNum': 'TRANSFER_STATUS',
                'multiple': false,
                'options': []
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': false,
        'height': 400,
        'columns': [
            {
                'label': '移交单号',
                'prop': 'transferNo',
                'sort': true
            },
            {
                'label': '运输单数量',
                'prop': 'signCount',
                'sort': true
            },
            {
                'label': '移交类型',
                'prop': 'transTypeText',
                'sort': true
            },
            {
                'label': '移交状态',
                'prop': 'transferStatusText',
                'sort': true
            },
            {
                'label': '附件',
                'prop': 'files',
                'type': 'photos',
                'ifHas': 'otp04070001',
                'sort': true
            },
            {
                'label': '客户',
                'prop': 'customerName',
                'sort': true
            },
            {
                'label': '接收人',
                'prop': 'receiptPersonName',
                'sort': true
            },
            {
                'label': '接收时间',
                'prop': 'receiptDate',
                'sort': true
            },
            {
                'label': '移交人',
                'prop': 'transferPersonName',
                'sort': true
            },
            {
                'label': '移交时间',
                'prop': 'transferDate',
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '接收',
                'size': 'small',
                'event': 'view',
                'ifHas': 'otp04070004'
            },
            {
                'type': 'text',
                'label': '打印',
                'size': 'small',
                'event': 'edit',
                'ifHas': 'otp04070005'
            }
        ],
        'leftOperation': true,
        'leftWidth': 120
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50]
    }
};
